import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Grid } from "@mui/material";
import {
  useCreateFacultyFieldsMutation,
  useUpdateFacultyFieldsMutation,
} from "api/faculty/faculty.mutation";
import { Modal } from "components/Modal";
import SwitchField from "components/SwitchField";
import TextField from "components/TextField";
import { handleError } from "functions/apiHandleError";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { schema } from "schema/faculty/createUpdateFieldModal";
import classes from "./style.module.scss";

export const CreateUpdateFieldModal = ({ open, onClose, facultyID, defaultData }) => {
  const { handleSubmit, reset, setError, control } = useForm({
    mode: "onChange",
    resolver: zodResolver(schema),
    defaultValues: {
      fa_name: "",
      en_name: "",
      ar_name: "",
      max_members: "",
      phd_active: false,
      bachelor_active: false,
      master_active: false,
      requires_an_interview: false,
    },
  });

  const createFacultyFieldsMutation = useCreateFacultyFieldsMutation();
  const updateFacultyFieldsMutation = useUpdateFacultyFieldsMutation();
  const loading = createFacultyFieldsMutation.isPending || updateFacultyFieldsMutation.isPending;

  const handleCloseModal = () => {
    reset({
      fa_name: "",
      en_name: "",
      ar_name: "",
      max_members: "",
      bachelor_active: false,
      master_active: false,
      phd_active: false,
      requires_an_interview: false,
    });
    onClose();
  };
  const handleSubmitForm = async (data) => {
    try {
      if (defaultData) {
        data.faculty = facultyID;
        await updateFacultyFieldsMutation.mutateAsync({ pk: defaultData?.id, data });
      } else {
        await createFacultyFieldsMutation.mutateAsync({
          faculty: facultyID,
          fa_name: data?.fa_name,
          en_name: data?.en_name,
          ar_name: data?.ar_name,
          max_members: data?.max_members,
          bachelor_active: data?.bachelor_active,
          master_active: data?.master_active,
          phd_active: data?.phd_active,
          requires_an_interview: data?.requires_an_interview,
        });
      }
      toast.success("با موفقیت انجام شد");
      handleCloseModal();
    } catch (err) {
      handleError({ err, setError });
    }
  };

  useEffect(() => {
    if (defaultData) {
      reset({
        fa_name: defaultData?.fa_name,
        en_name: defaultData?.en_name,
        ar_name: defaultData?.ar_name,
        max_members: String(defaultData?.max_members),
        bachelor_active: defaultData?.bachelor_active,
        master_active: defaultData?.master_active,
        phd_active: defaultData?.phd_active,
        requires_an_interview: defaultData?.requires_an_interview,
      });
    }
  }, [defaultData]);

  return (
    <Modal
      open={open}
      title={defaultData ? "ویرایش رشته" : "ایجاد رشته"}
      onClose={handleCloseModal}
      maxWidth="xs"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={loading}
            color={defaultData ? "primary" : "success"}
            onClick={handleSubmit(handleSubmitForm)}
          >
            ثبت
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={handleCloseModal}>
            بستن
          </Button>
        </>
      }
    >
      <Grid
        container
        spacing={3}
        component="form"
        onSubmit={handleSubmit(handleSubmitForm)}
        className={classes.wrapper}
      >
        <Grid item xs={12}>
          <TextField label="فارسی" required control={control} name="fa_name" />
        </Grid>
        <Grid item xs={12}>
          <TextField label="انگلیسی" required control={control} name="en_name" />
        </Grid>
        <Grid item xs={12}>
          <TextField label="عربی" required control={control} name="ar_name" />
        </Grid>
        <Grid item xs={12}>
          <TextField label="حداکثر ثبت نامی" required number control={control} name="max_members" />
        </Grid>
        <Grid item xs={12}>
          <SwitchField
            name="bachelor_active"
            control={control}
            label="در کارشناسی فعال باشد؟"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <SwitchField name="master_active" control={control} label="در ارشد فعال باشد؟" required />
        </Grid>
        <Grid item xs={12}>
          <SwitchField name="phd_active" control={control} label="در دکتری فعال باشد؟" required />
        </Grid>
        <Grid item xs={12}>
          <SwitchField
            name="requires_an_interview"
            control={control}
            label="نیاز به مصاحبه دارد؟"
            required
          />
        </Grid>
      </Grid>
    </Modal>
  );
};
